import { apiGet, apiPost, apiPatch, apiDelete } from "src/configs/globalFunctions";

export function fetchEventos() {
  return new Promise((resolve) => {
    apiGet("/minipay/eventos", {
      done: (resp) => resolve(resp.data || []),
      error: () => resolve([]),
    });
  });
}

export function createEvento({ nome, valor, descricao, data, diasAntesAlertas }) {
  return new Promise((resolve, reject) => {
    apiPost("/minipay/eventos", {
      body: { nome, valor, descricao, data, diasAntesAlertas },
      done: (resp) => resolve(resp.data),
      error: () => reject(new Error("Falha ao criar evento")),
    });
  });
}

export function updateEventoApi(eventoId, { nome, valor, descricao, data, diasAntesAlertas }) {
  return new Promise((resolve, reject) => {
    apiPatch(`/minipay/eventos/${eventoId}`, {
      body: { nome, valor, descricao, data, diasAntesAlertas },
      done: (resp) => resolve(resp.data),
      error: () => reject(new Error("Falha ao editar evento")),
    });
  });
}

export function deleteEventoApi(eventoId) {
  return new Promise((resolve, reject) => {
    apiDelete(`/minipay/eventos/${eventoId}`, {
      done: () => resolve(),
      error: () => reject(new Error("Falha ao excluir evento")),
    });
  });
}

export function addParticipantesAoEventoApi(eventoId, participanteIds) {
  return new Promise((resolve, reject) => {
    apiPost(`/minipay/eventos/${eventoId}/participantes`, {
      body: { participanteIds },
      done: (resp) => resolve(resp.data),
      error: () => reject(new Error("Falha ao adicionar participantes ao evento")),
    });
  });
}

export function removerParticipanteDoEventoApi(eventoId, participanteId) {
  return new Promise((resolve, reject) => {
    apiDelete(`/minipay/eventos/${eventoId}/participantes/${participanteId}`, {
      done: (resp) => resolve(resp.data),
      error: () => reject(new Error("Falha ao remover participante do evento")),
    });
  });
}

export function definirPagamentoApi(eventoId, participanteId, pago) {
  return new Promise((resolve, reject) => {
    apiPatch(`/minipay/eventos/${eventoId}/participantes/${participanteId}`, {
      body: { pago },
      done: (resp) => resolve(resp.data),
      error: () => reject(new Error("Falha ao atualizar pagamento")),
    });
  });
}
